import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import {Link, useHistory} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Confirm from "v4/components/ui/Confirm/Confirm";
import {QUOTE_DELETE} from "v4/data/apiRoutes";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useToggle from "v4/hooks/useToggle";
import useDeleteEntity from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/hooks/useDeleteEntity";
import QuoteLinesVoter from "v4/voters/quoteLinesVoter";
import TableLink from "v4/components/utils/TableLink/TableLink";
import PdfButton from "v4/features/front/generatePdf/components/PdfButton/PdfButton";
import {getQuotePdfFiles} from "v4/utils/quotePdfFiles";

export default function ProspectQuotesTabRowActions({rowId, onDuplicate, isSplit, files, name, updateHandler}) {
    const {t} = usePolTranslation();
    const { getRouteByNativeIdentifier, currentRoute } = useNavigation();
    const [isConfirmOpen, toggleConfirmOpen] = useToggle();
    const deleteContact = useDeleteEntity(QUOTE_DELETE, rowId, toggleConfirmOpen);
    const {push} = useHistory();

    const handleRelaunch = () => {
        const openTasksRoute = getRouteByNativeIdentifier('detail_open_tasks');
        if (!openTasksRoute) return;

        push({
            pathname: `/${resolveUrl(openTasksRoute.url, { prospect: currentRoute.params.prospect })}/add`,
            state: {relaunchId: rowId}
        });
    };

    const {canAccessQuoteLines} = QuoteLinesVoter();

    return (
        <>
            <TableLink href={({pathname}) => `${pathname}/${rowId}`}/>
            <ul className="table-actions">
                <li className={`table-actions__pdf ${getQuotePdfFiles(files).length > 0 ? 'has-dropdown' : ''}`}>
                    <PdfButton variant="listing"
                               files={files}
                               quoteId={rowId}
                               quoteName={name}
                               updateHandler={updateHandler}/>
                </li>
                <li data-for="row-action" data-tip={t('edit')}>
                    <Link to={({pathname}) => `${pathname}/${rowId}/edit`}>
                        <PolIcon icon="edit"/>
                    </Link>
                </li>
                <li onClick={!isSplit ? onDuplicate(rowId) : undefined}
                    data-for="row-action"
                    data-tip={t(isSplit ? 'no_action_splitted_quote' : 'duplicate_action_quote')}
                    data-disabled={isSplit}>
                    <PolIcon icon="copy"/>
                </li>
                {canAccessQuoteLines() && (
                    <li onClick={!isSplit ? handleRelaunch : undefined}
                        data-for="row-action"
                        data-tip={t(isSplit ? 'no_action_splitted_quote' : 'recovery_action_quote')}
                        data-disabled={isSplit}>
                        <PolIcon icon="file-export-solid"/>
                    </li>
                )}
                <li data-for="row-action" data-tip={t('delete')}>
                    <PolIcon icon="trash" onClick={toggleConfirmOpen}/>
                </li>
            </ul>
            <ReactTooltip id="row-action" effect="solid"/>
            <Confirm title={t('delete')}
                     isOpen={isConfirmOpen}
                     cancelAction={toggleConfirmOpen}
                     confirmAction={deleteContact}>
                <p>{t('popup_validation_suppression')}</p>
            </Confirm>
        </>
    )
}
